import Vue from  'vue'
import VueI18n from "vue-i18n"
import messages from "../locale/message";

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: localStorage.getItem('locale') || 'pt',
    fallbackLocale:'pt',
    messages,
    silentTranslationWarn: true
});

export {
    i18n
}